import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hide-on-error"
export default class extends Controller {
  connect() {
    // It is possible for the JS to run AFTER the image has been loaded/failed to load.
    // This handles both cases.
    if (this.element.complete && this.element.naturalWidth === 0) {
      this.element.style.opacity = 0;
    } else {
      this.element.addEventListener('error', () => {
        this.element.style.opacity = 0;
      });
    }
  }
}